{
  "pageTitle": "Manual Actions",
  "startScraping": "Start Scraping",
  "startScrapingDesc": "Trigger invoice scraping for all addresses and providers.",
  "viewLiveLogs": "View Live Logs",
  "processPayments": "Process Payments",
  "processPaymentsDesc": "Review and process pending invoices for payment.",
  "viewPendingInvoices": "View Pending Invoices"
}
